import React from 'react';
import { API_BASE } from '../../../Libs/Api/Config'

// Ortam banner'ı: REACT_APP_ENV PROD DEĞİLSE (TEST/DEV/PREVIEW) sayfanın üstünde sabit
// bir uyarı çubuğu gösterir. Prod'da hiç render edilmez (null döner).
// Hangi backend'e bağlı olduğunu da yazar → yanlış ortamda işlem yapmayı önler.
export default function EnvBanner() {
    const env = (process.env.REACT_APP_ENV || '').toUpperCase();
    if (!env || env === 'PROD' || env === 'PRODUCTION') return null;

    const api = (API_BASE || '').replace(/^https?:\/\//, '');

    return (
        <div
            role="status"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 2147483647,
                height: 18,
                lineHeight: '18px',
                textAlign: 'center',
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: 0.3,
                color: '#1f2937',
                background: '#f59e0b',
                boxShadow: '0 1px 4px rgba(0,0,0,.2)',
                fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
                userSelect: 'none',
                pointerEvents: 'none',
            }}
        >
            ⚠ {env} ORTAMI{api ? ` · ${api}` : ''} · CANLI DEĞİL
        </div>
    );
}
